import { useEffect } from 'react';
import { Form, Modal, Select, Input } from 'antd';
import { cardTypes } from '@utils/constants';

const IdCardEditModal = ({ open, onCancel, onOk, formData, title = '编辑证件信息' }) => {
    const [form] = Form.useForm();

    // 监听证件类型变化，用于动态验证
    const idcardType = Form.useWatch('idcardType', form);

    // 当模态框打开时，设置表单初始值
    useEffect(() => {
        if (open) {
            form.setFieldsValue({
                idcardType: formData?.idcardType || undefined,
                idCard: formData?.idCard || undefined,
            });
        } else {
            form.resetFields();
        }
    }, [open, formData, form]);

    // 表单提交处理
    const handleSubmit = async () => {
        try {
            const values = await form.validateFields();
            onOk(values);
        } catch (error) {
            console.error('表单验证失败:', error);
        }
    };

    return (
        <Modal title={title} open={open} onCancel={onCancel} onOk={handleSubmit} centered destroyOnHidden>
            <Form form={form} labelCol={{ span: 6 }} wrapperCol={{ span: 18 }} autoComplete="off">
                <Form.Item label="证件类型" name="idcardType" rules={[{ required: true, message: '请选择证件类型' }]}>
                    <Select placeholder="请选择证件类型">
                        {cardTypes.map(item => (
                            <Select.Option key={item.code} value={item.code}>
                                {item.name}
                            </Select.Option>
                        ))}
                    </Select>
                </Form.Item>

                <Form.Item
                    label="证件号"
                    name="idCard"
                    rules={[
                        () => ({
                            validator(_, value) {
                                if (!value) {
                                    return Promise.reject('请输入证件号码');
                                }

                                // 当选择身份证类型时，验证身份证号格式
                                if (idcardType === 1) {
                                    const reg = /^\d{17}[\dxX]$/;
                                    if (reg.test(value)) {
                                        return Promise.resolve();
                                    }
                                    return Promise.reject('身份证号格式不正确');
                                }

                                // 其他证件类型使用通用验证
                                const reg = /^[0-9a-z]+$/i;
                                if (reg.test(value)) {
                                    return Promise.resolve();
                                }
                                return Promise.reject('证件号格式不正确');
                            },
                        }),
                    ]}
                >
                    <Input placeholder="请输入证件号码" />
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default IdCardEditModal;
